import React from 'react';
import { Translate } from 'react-localize-redux';
import Flex from '@components/layout/flex';
import SidebarCtrl from '@webapp/controllers/sidebar';
import SidebarItemSong from '@components/basics/sidebar-item/sidebar-item-song';
import SidebarItem from '@components/basics/sidebar-item';
import SidebarWrapper from '@components/layout/sidebar-wrapper';
import SquareCover from '@components/basics/square-cover';
import { getRoute, checkOwnerId } from '@webapp/utils/split-changes';
import Typography from '@components/basics/typography';
import CatalogRelease from '@common/types/catalog/catalog-release';
import { OwnershipState } from '@webapp/store/ownership/state';

interface SidebarContentProps {
  activeRelease?: CatalogRelease;
  assetType: string;
  releaseId: string;
  trackId: string;
  owners: OwnershipState;
  userId: string;
  type: string;
  lock: string;
  songName: string;
}

export const SidebarContent: React.FC<SidebarContentProps> = ({
  activeRelease,
  assetType,
  releaseId,
  trackId,
  owners,
  userId,
  type,
  lock,
  songName,
}) => {
  return (
    <SidebarWrapper>
      <Flex className="mb-30" alignItems="center" gap={10}>
        <SquareCover
          className="artwork"
          size={32}
          borderRadius={4}
          src={activeRelease?.cover_url}
          alt={activeRelease?.title}
        />
        <Typography weight="700">{activeRelease?.title}</Typography>
      </Flex>
      {assetType === 'track' ? (
        <SidebarCtrl title={<Translate id="RELEASE.SIDEBAR.LIST.TRACKLIST" />}>
          {activeRelease?.tracks
            ?.filter((track) => checkOwnerId(owners, track.id, userId))
            .map((track, index) => (
              <SidebarItem
                route={getRoute(releaseId, type, lock, track)}
                active={track.id === trackId}
                disabled={false}
              >
                <SidebarItemSong
                  number={`${index + 1}`}
                  text={track.name}
                  active={track.id === trackId}
                  isLoading={false}
                  onRetry={() => null}
                  onRemove={() => null}
                  disableRemove={true}
                  disableSorting={true}
                />
              </SidebarItem>
            ))}
        </SidebarCtrl>
      ) : (
        <SidebarCtrl title={<Translate id="RELEASE.SIDEBAR.LIST.MERCHLIST" />}>
          <SidebarItem active={true} disabled={false}>
            <SidebarItemSong
              number={`01`}
              text={songName}
              active={true}
              isLoading={false}
              onRetry={() => null}
              onRemove={() => null}
              disableRemove={true}
              disableSorting={true}
            />
          </SidebarItem>
        </SidebarCtrl>
      )}
    </SidebarWrapper>
  );
};
